module.exports = __webpack_public_path__ + "onzegraf.jpg?0feaac4db2b5d1131c4030302852a384";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/onzegraf.jpg
// module id = 142
// module chunks = 0